module.exports = "h2 {\n  text-align: center;\n  background: #673ab7;\n  color: rgba(255, 255, 255, 0.87); }\n\nmd-dialog-actions button {\n  position: fixed;\n  bottom: 12%;\n  right: 20%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/dialog/dialog.component.sass
// module id = ./src/app/dialog/dialog.component.sass
// module chunks = main